export interface ActiveFilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

/** Shared "removable active-filter chip" row for all four Accounting Reports (EPN-77) — no prior
 * component like this existed anywhere in the app; every report page composes its own filter state and
 * passes the currently-active ones in here rather than duplicating this markup per page. */
export function ActiveFilterChips({ chips, onClearAll }: { chips: ActiveFilterChip[]; onClearAll: () => void }) {
  if (chips.length === 0) return null;

  return (
    <div className="active-filter-chips" aria-label="Active filters">
      {chips.map((chip) => (
        <span className="filter-chip" key={chip.key}>
          {chip.label}
          <button type="button" onClick={chip.onRemove} aria-label={`Remove filter: ${chip.label}`}>
            ×
          </button>
        </span>
      ))}
      <button type="button" className="link" onClick={onClearAll}>
        Clear all
      </button>
    </div>
  );
}
